module.exports = __webpack_public_path__ + "img/t_icon_4.4595b1ec.svg";